module.exports = __webpack_public_path__ + "img/hot.7ee55700.png";